<template>
  <div class="[ c-cookie-banner__body ]">
    <div>
      <div class="[ c-cookie-banner__back-button-wrapper ]">
        <button v-on:click="goBack()"
                class="[ c-cookie-banner__button  c-cookie-banner__back-button  c-cookie-banner__button--primary ]"
                v-html="$t('banner.buttons.back')"/>
      </div>
      <div class="[ c-cookie-banner__text ]" v-html="compiledPrivacyContent">
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PrivacyTerms',
  props: {
    dataProtectionTerms: Object,
    language: String,
    privacyContentPath: String
  },
  data: function () {
    return {
      privacyContent: null
    }
  },
  created () {
    this.loadContent()
  },
  methods: {
    goBack: function () {
      this.$emit('goBack')
    },
    loadContent: function () {
      axios.get(this.privacyContentPath)
        .then(result => {
          this.privacyContent = result.data
        })
        .catch(error => {
          this.privacyContent = `Error occurred fetching Content Data: ${error.toString()}`
        })
    }
  },
  computed: {
    compiledPrivacyContent: function () {
      return this.privacyContent
    }
  }
}
</script>
